/**
 * BAROQUE_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for the Baroque Genre (Bach, Vivaldi, Handel).
 * Features:
 * - Terraced Dynamics (Stepwise volume changes)
 * - Motor Rhythm (Continuous subdivision)
 * - Fast Functional Harmony (Circle of Fifths, functional resolutions)
 * - Polyphonic Texture (Voice independence)
 */

import { ACTIVE_ARCHETYPE } from './BaseArchetype.js';

export const BAROQUE_ARCHETYPE = {
    ...ACTIVE_ARCHETYPE,

    // Voice Distribution: Ratio of activity.
    // Polyphonic texture means voices are often equally active, but bass (Basso Continuo)
    // is fundamental.
    voiceDistribution: {
        ...ACTIVE_ARCHETYPE.voiceDistribution,
        low: 0.30,  // Basso Continuo / Cello
        mid: 0.35,  // Inner voices (Counterpoint)
        high: 0.35, // Melody / Soprano
        tolerance: 0.10, // Strict balance for counterpoint
        tuttiThreshold: 0.95 // Rare "Wall of Sound" compared to Cinematic
    },

    // Dynamic Curve: Velocity behavior.
    // Terraced Dynamics: Sections are either Loud or Quiet, with immediate transitions.
    // 'stepwise' shape tells ScoringEngine to punish smooth ramps.
    dynamicRange: {
        ...ACTIVE_ARCHETYPE.dynamicRange,
        minVariance: 0.15, // Still needs contrast between sections
        targetVariance: 0.20,
        dynamicShape: 'stepwise' // NEW: Requires "Plateaus and Steps"
    },

    // Interval Entropy: Probability of stepwise motion.
    // Strict Voice Leading. Large leaps are usually followed by stepwise recovery.
    // High ratio of stepwise motion.
    intervalEntropy: {
        ...ACTIVE_ARCHETYPE.intervalEntropy,
        stepRatio: 0.75, // Very high stepwise requirement (smooth voice leading)
        tolerance: 0.10
    }
};
